import React, { useState } from 'react';
import { Offcanvas, Nav, Image, Button } from 'react-bootstrap';
import styles from './../style/MobileMenu.module.scss';

import FeedbackForm from './FeedbackForm';

const MobileMenu = ({ show, handleClose, options, menu, catalog, user_profile_type }) => {
  const [expandedSections, setExpandedSections] = useState({
    catalog: true,
    info: false,
    lk: false
  });

  const toggleSection = (section) => {
    setExpandedSections(prev => ({
      ...prev,
      [section]: !prev[section]
    }));
  };

  const worktime = 'worktime' in options ? options.worktime : { one: '', two: '' };

  const [show_feedback, set_feedback] = useState(false);

  const close_feedback = () => {
    set_feedback(false);
  };

  return (
    <Offcanvas 
      show={show} 
      onHide={handleClose} 
      placement="end"
      className={styles.offcanvas}
    >
      {/* Шапка Offcanvas */}
      <Offcanvas.Header className={styles.header}>
        <div className={styles.headerContent}>
          <div className={styles.headerTitle}>Меню</div>
          <button onClick={handleClose} className={styles.closeButton}>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1 1L15 15" stroke="black"/>
              <path d="M15 1L1 15" stroke="black"/>
            </svg>
          </button>
        </div>
      </Offcanvas.Header>
      
      {/* Тело Offcanvas */}
      <Offcanvas.Body className={styles.body}>
        <div className={styles.menuSection}>
          <a href={options?.link_akcii} className={styles.menuTitle}>Акции</a>
        </div>

        {user_profile_type != `legal` &&
          <>
            <div className={styles.menuSection}>
              <div 
                className={styles.menuTitleWrapper}
                onClick={() => toggleSection('catalog')}
              >
                <h3 className={styles.menuTitle}>Каталог</h3>
                <svg 
                  width="11" 
                  height="6" 
                  viewBox="0 0 11 6" 
                  fill="none" 
                  xmlns="http://www.w3.org/2000/svg"
                  className={`${styles.arrowIcon} ${expandedSections.catalog ? styles.arrowIconRotated : ''}`}
                >
                  <path d="M10 5L5.5 1L1 5" stroke="black" strokeWidth="1"/>
                </svg>
              </div>
              {expandedSections.catalog && (
                <Nav className={styles.menu}>
                  {catalog.map((item, index) => (
                    <React.Fragment key={index}>
                      <Nav.Link 
                        href={item.link} 
                        className={item.is_current ? styles.menuItemActive : styles.menuItem}
                        onClick={handleClose}
                      >
                        <span dangerouslySetInnerHTML={{__html: item.pagetitle.replace(/<[^>]+>/g, ' ')}} />
                      </Nav.Link>
                      {item.child &&
                        <Nav.Item className={styles.childMenu}>
                          {item.child.map((citem, j) => (
                            <Nav.Link 
                              key={j} 
                              href={citem.link} 
                              className={citem.is_current ? styles.menuItemActive : styles.menuItem}
                              onClick={handleClose}
                            >
                              <span dangerouslySetInnerHTML={{__html: citem.pagetitle.replace(/<[^>]+>/g, ' ')}} />
                            </Nav.Link>
                          ))}
                        </Nav.Item>
                      }
                    </React.Fragment>
                  ))}
                </Nav>
              )}
            </div>

            <div className={styles.divider}></div>
          </>
        }

        {/* Основное меню */}
        <div className={styles.menuSection}>
          <div 
            className={styles.menuTitleWrapper}
            onClick={() => toggleSection('info')}
          >
            <h3 className={styles.menuTitle}>Информация</h3>
            <svg 
              width="11" 
              height="6" 
              viewBox="0 0 11 6" 
              fill="none" 
              xmlns="http://www.w3.org/2000/svg"
              className={`${styles.arrowIcon} ${expandedSections.info ? styles.arrowIconRotated : ''}`}
            >
              <path d="M10 5L5.5 1L1 5" stroke="black" strokeWidth="1"/>
            </svg>
          </div>
          {expandedSections.info && (
            <Nav className={styles.menu}>
              {menu.map((item, index) => (
                <Nav.Link 
                  key={index} 
                  href={item.link} 
                  className={item.is_current ? styles.menuItemActive : styles.menuItem}
                  onClick={handleClose}
                >
                  <span dangerouslySetInnerHTML={{__html: item.pagetitle}} />
                </Nav.Link>
              ))}
            </Nav>
          )}
        </div>

        <div className={styles.menuSection}>
          <div 
            className={styles.menuTitleWrapper}
            onClick={() => toggleSection('lk')}
          >
            <h3 className={styles.menuTitle}>Личный кабинет</h3>
            <svg 
              width="11" 
              height="6" 
              viewBox="0 0 11 6" 
              fill="none" 
              xmlns="http://www.w3.org/2000/svg"
              className={`${styles.arrowIcon} ${expandedSections.lk ? styles.arrowIconRotated : ''}`}
            >
              <path d="M10 5L5.5 1L1 5" stroke="black" strokeWidth="1"/>
            </svg>
          </div>
          {expandedSections.lk && (
            <Nav className={styles.menu}>
              <Nav.Link 
                href={options?.link_lk || '/'}
                className={styles.menuItem}
              >
                Личный кабинет
              </Nav.Link>
              <Nav.Link 
                href={options?.link_cart || '/'}
                className={styles.menuItem}
              >
                Корзина
              </Nav.Link>
              <Nav.Link 
                href={options?.link_favorite || '/'}
                className={styles.menuItem}
              >
                Избранное
              </Nav.Link>
            </Nav>
          )}
        </div>

        <div className={styles.divider}></div>

        <div className={styles.topRowEnd}>
          <Button onClick={() => set_feedback(true)} className='text-white px-5' variant='primary'>Связаться</Button>

          {/* TG */}
          {'tglink' in options &&
            <a href={options.tglink} target="_blank" rel="noopener noreferrer">
              <Image alt="TG" src={options?.tgicon || ''} width="35" height="35" />
            </a>
          }
          {/* WA */}
          {'walink' in options &&
            <a href={options.walink} target="_blank" rel="noopener noreferrer">
              <Image alt="WA" src={options?.waicon || ''} width="35" height="35" />
            </a>
          }

          <FeedbackForm
            title={`Нужна консультация?`}
            text={`Свяжитесь с нами и мы оперативно проконсультируем вас`}
            btn={`Отправить`}
            data={[]}
            show={show_feedback}
            handleClose={() => close_feedback()}
          />
        </div>

        {/* Working hours */}
        <div className={styles.workTimeBlock}>
          <Image alt="Время" className="me-2" src="/images/worktime.svg" width="16" height="16" />
          <div>
            <div className={styles.workTimeText}>
              {worktime.one}
            </div>
            <div className={styles.workTimeSubtext}>
              {worktime.two}
            </div>
          </div>
        </div>

      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default MobileMenu;